import React from 'react';
import classNames from 'classnames';
export default function Loader(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Loading...' : _ref$text,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'ob-loader-wrapper zb-flex zb-flex-center js-loader')
  }, /*#__PURE__*/React.createElement("div", {
    className: "zb-loader-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "zb-loader-content"
  }, /*#__PURE__*/React.createElement("span", {
    className: "zb-loader"
  }), /*#__PURE__*/React.createElement("span", {
    className: "zb-loader-text js-loader-text"
  }, text))));
}